import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const rise: gsapTimelineFunc = (target) => {
  return gsap.timeline().fromTo(
    target,
    {
      duration: 0,
      opacity: 0,
      y: '100%',
      ease: Power1.easeOut,
      transformOrigin: '50% 50%',
    },
    {
      duration: 1,
      opacity: 1,
      scale: 1,
      y: '0%',
      transformOrigin: '50% 50%',
    }
  );
};
